<nz-drawer
    [nzClosable]="true"
    [nzVisible]="open"
    nzPlacement="right"
    [nzWidth]="_mobile() ? '100%' : '550px'"
    [nzBodyStyle]="{ position: 'relative' }"
    nzTitle="Выберите цвет"
    (nzOnClose)="close()">
    <ng-container *nzDrawerContent>
        <div class="select-color-drawer-root layout flex wrap scroll-y" [style.opacity]="op()">
            @for (color of colors(); track color) {
                <i class="scdr-color" [style.background-color]="color" (click)="close(color)"></i>
            }
        </div>
    </ng-container>
</nz-drawer>
